import React from 'react';

import Link from 'components/link/link';

import './card.scss';

interface Props {
  className?: string;
  header: string;
  description?: string;
  theme?: cardTheme;
  layout?: cardLayout;
  imgSrc?: string;
  url?: string;
  meta?: string;
}

export enum cardTheme {
  default = 'default',
  dark = 'dark',
  crisp = 'crisp',
  resources = 'resources'
}

export enum cardLayout {
  default = 'default',
  long = 'long',
  small = 'small',
  giant = 'giant'
}

const Card = ({
  className,
  header,
  description,
  imgSrc,
  theme = cardTheme.default,
  layout = cardLayout.default,
  url,
  meta
}: Props) => {
  const block = 'newcard';

  const cardContents = (
    <div className={`${block}__contents`}>
      {imgSrc && (
        <div className={`${block}__img`}>
          <div
            className={`${block}__img-inner`}
            style={{
              backgroundImage: `url(${imgSrc})`
            }}
          />
        </div>
      )}
      <div className={`${block}__text`}>
        {meta && <div className={`${block}__meta`}>{meta}</div>}
        <h5 className={`${block}__header`}>{header}</h5>
        {description && (
          <div
            className={`${block}__blurb`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  );

  return (
    <article
      className={`${block} ${block}--theme-${theme} ${block}--layout-${layout} ${className ||
        ''}`}
    >
      {!url ? (
        cardContents
      ) : (
          /* eslint-disable-next-line react/jsx-indent */
          <Link block className={`${block}__link`} to={url}>
            {cardContents}
          </Link>
        )}
    </article>
  );
};

export default Card;
